import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";

export const impressionBullsEyeTgHalfcardMount = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SWIGGY_PLAN_BULLS_EYE_HALFCARD,
        context,
    });
};

export const impressionBullsEyeTgHalfcardGratificationMount = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SWIGGY_PLAN_BULLS_EYE_HALFCARD_GRATIFICATION,
        context,
    });
};

export const impressionBullsEyeTgAddCta = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    value: string,
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADD_SWIGGY_ONE,
        label: value,
        context,
    });
};

export const impressionBullsEyeTgSkipCta = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    value: string,
    context: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CONTINUE_TO_CART,
        label: value,
        context,
    });
};

export const clickBullsEyeTgAddCta = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    value: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_SWIGGY_ONE,
        context,
        label: value,
    });
};

export const clickBullsEyeTgSkipCta = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    value: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CONTINUE_TO_CART,
        context,
        label: value,
    });
};

export const clickMakeItFreeCta = (clickEvent: AnalyticsContextValue["clickEvent"], context: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_MAKE_IT_FREE,
        context,
        label: CLICK_ACTIONS.CLICK_MAKE_IT_FREE,
    });
};

export const clickViewAllBenefitsCta = (clickEvent: AnalyticsContextValue["clickEvent"], context: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SUPER_VIEW_ALL_BENEFITS_CTA,
        context,
    });
};
